import React from 'react'

import ConsoleDialog from './ConsoleDialog'

export function legacyHtmlToText(html = '') {
    return String(html)
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim()
}

export default function StatusDialog({ show, title, text, html, content, icon, onClose, t }) {
    const success = icon === 'success'
    const message = text || legacyHtmlToText(html)
    return <ConsoleDialog
        show={Boolean(show)}
        onClose={onClose}
        title={title || (success ? t('成功') : t('提示'))}
        icon={success ? 'fa-check' : 'fa-exclamation-triangle'}
        tone={success ? 'success' : 'danger'}
        closeLabel={t('关闭')}
        footer={<button type="button" className="console-button is-primary" onClick={onClose}>{t('知道了')}</button>}
    >
        {content
            ? <div className="console-dialog__message">{content}</div>
            : <p className="console-dialog__message">{message}</p>}
    </ConsoleDialog>
}
